import { render, staticRenderFns } from "./OpenSessionCard.vue?vue&type=template&id=2f161d32&scoped=true&"
import script from "./OpenSessionCard.vue?vue&type=script&lang=js&"
export * from "./OpenSessionCard.vue?vue&type=script&lang=js&"
import style0 from "./OpenSessionCard.vue?vue&type=style&index=0&id=2f161d32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f161d32",
  null
  
)

export default component.exports